import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { DoeState, state } from './state';
import { getters } from '@/modules/DOE/store/getters';
import { actions } from '@/modules/DOE/store/actions';
import { mutations } from '@/modules/DOE/store/mutations';

const module: Module<DoeState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { DoeState };
